import React, { Component } from 'react';
import CollapseContainer from './CollapseContainer';
import OptionsList from './OptionsList';
import { durationOptions, sortOptions } from '../../utils/spaConstants';
import FilterResultsButton from '../Filter/FilterResultsButton';


class FilterOptions extends Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedDuration: 'Any',
            selectedSort: '',
            openDuration: false,
            openSort: false
        }

        this.onDurationOpen = this.onDurationOpen.bind(this);
        this.onDurationClose = this.onDurationClose.bind(this);
        this.onSortClose = this.onSortClose.bind(this);
        this.onSortOpen = this.onSortOpen.bind(this);
        this.sortSelect = this.sortSelect.bind(this);
        this.durationSelect = this.durationSelect.bind(this);

    }

    onDurationOpen = () => this.setState({ openDuration: true })
    onDurationClose = () => this.setState({ openDuration: false });
    onSortClose = () => this.setState({ openSort: false });
    onSortOpen = () => this.setState({ openSort: true });

    durationSelect(event) {
        let selectedDuration = event.target.textContent.trim();
        this.props.actions.filterByDuration(selectedDuration, this.state.selectedSort);
        this.setState({ selectedDuration });
    }

    sortSelect(event) {
        let selectedSort = event.target.textContent.trim();
        this.props.actions.sortAvailableServices(selectedSort);
        this.setState({ selectedSort });
    }


    render() {

        let { selectedDuration, selectedSort } = this.state;

        return (
            <div className='mobile-filter-tab-content'>
                <div className='service-availability-container service-availability-container-mobile'>
                    <section className='mobile-filter-sections duration'>
                        <div className='availablity-heading  availablity-heading-mobile padding-5'>
                            <h2 className='align-center spa-bold'>Duration </h2>
                        </div>
                        <div className='mobile-collapse-container mobile-user-list'>
                            <CollapseContainer onCollapseClose={this.onDurationClose} triggerText={selectedDuration || 'Any'} isOpen={this.state.openDuration} onCollapseTriggerClick={this.onDurationOpen} >
                                <OptionsList selectedOption={selectedDuration} onSelect={this.durationSelect} options={durationOptions} />
                            </CollapseContainer>
                        </div>
                    </section>
                    <section className='mobile-filter-sections sort'>
                        <div className='availablity-heading  availablity-heading-mobile padding-5'>
                            <h2 className='align-center spa-bold'>Sort </h2>
                        </div>
                        <div className='mobile-collapse-container mobile-user-list'>
                            <CollapseContainer onCollapseClose={this.onSortClose} triggerText={selectedSort || 'Any'} isOpen={this.state.openSort} onCollapseTriggerClick={this.onSortOpen} >
                                <OptionsList selectedOption={selectedSort} onSelect={this.sortSelect} options={sortOptions} />
                            </CollapseContainer>
                        </div>
                    </section>
                    <span className='filter-button-container padding-10'>
                        <FilterResultsButton isServicesLoading={this.props.isServicesLoading} onClick={this.props.onFilterButtonClick} count={this.props.count} />
                        {
                            !this.props.hideReset &&
                            <span className='d-md-none'>
                                <span className='banner-text filtered-reset font-size-p1 gotham-xn-medium' data-test-id="reset-button" onClick={this.props.resetFilter}>
                                    <svg focusable="false" className="svg-icon svg-icon-refresh"> <use xlinkHref="#icon-refresh" data-test-id="reset-button-undo" ></use></svg> Reset Filters
                            </span>
                            </span>
                        }
                    </span>
                </div>

            </div>
        )
    }
}

export default FilterOptions;